const initialState = {
    isModalVisible: false,
  };
  
  const contactUsModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_CONTACT_US_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_CONTACT_US_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default contactUsModalReducer;
  